// ** Modules
import { motion } from 'framer-motion';

// ** Types
import type React from 'react';

export type FadeInViewProps = {
	children: React.ReactNode;
	delay?: number;
	offsetY?: number;
	duration?: number;
};

const FadeInView = ({ children, delay = 0, offsetY = 24, duration = 0.5 }: FadeInViewProps) => {
	return (
		<motion.div
			initial={{ opacity: 0, y: offsetY }}
			whileInView={{ opacity: 1, y: 0 }}
			viewport={{ once: true, amount: 0.15 }}
			transition={{ duration, delay, ease: 'easeOut' }}
			style={{ width: '100%' }}
		>
			{children}
		</motion.div>
	);
};

export default FadeInView;
